// Firebase config: read from environment so production can inject
// the correct values and we avoid shipping stale hard-coded keys.
//
// For local dev, create `.env.local` in `stock-screener-frontend/` with:
// REACT_APP_FIREBASE_API_KEY=...
// REACT_APP_FIREBASE_AUTH_DOMAIN=...
// REACT_APP_FIREBASE_PROJECT_ID=...
// REACT_APP_FIREBASE_STORAGE_BUCKET=...
// REACT_APP_FIREBASE_MESSAGING_SENDER_ID=...
// REACT_APP_FIREBASE_APP_ID=...
// REACT_APP_FIREBASE_MEASUREMENT_ID=...

type FirebaseConfig = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string | undefined;
};

const requiredEnv = (key: string): string => {
  const value = process.env[key];
  if (!value) {
    return '';
  }
  return value;
};

export const firebaseConfig: FirebaseConfig = {
  apiKey: requiredEnv('REACT_APP_FIREBASE_API_KEY'),
  authDomain: requiredEnv('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  projectId: requiredEnv('REACT_APP_FIREBASE_PROJECT_ID'),
  storageBucket: requiredEnv('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: requiredEnv('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: requiredEnv('REACT_APP_FIREBASE_APP_ID'),
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
